export const CONFIG_PIE_CHART = {
  appendPadding: 10,
  angleField: 'value',
  colorField: 'type',
  radius: 1,
  innerRadius: 0.6,
  autoFit: false,
  height: 180,
  width: 400,
  label: {
    type: 'inner',
    offset: '-30%',
    content: '',
    style: {
      textAlign: 'center',
      fontSize: 14,
      fill: 'red'
    }
  },
  interactions: [
    {
      type: 'element-selected'
    },
    {
      type: 'element-active'
    }
  ],
  statistic: {
    title: false,
    content: {
      style: {
        whiteSpace: 'pre-wrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      },
      content: ''
    }
  }
};

export const CONFIG_COLUMN = {
  label: {
    position: 'middle',
    style: {
      fill: '#FFFFFF',
      opacity: 0.6
    }
  },
  xAxis: {
    label: {
      autoHide: true,
      autoRotate: false
    }
  }
};

export const CONFIG_AREA = {
  xAxis: {
    range: [0, 1],
    tickCount: 5
  },
  areaStyle: () => {
    return {
      fill: 'l(270) 0:#ffffff 0.5:#7ec2f3 1:#1890ff'
    };
  },
  smooth: true,
  animation: {
    appear: {
      animation: 'path-in',
      duration: 5000
    }
  }
};

export const CONFIG_LINE = {
  legend: {
    position: 'top'
  },
  smooth: true,
  animation: {
    appear: {
      animation: 'path-in',
      duration: 5000
    }
  }
};

export const CONFIG_BAR = {
  legend: {
    position: 'top-left'
  }
};

export const CONFIG_ROSE = {
  radius: 0.9,
  state: {
    active: {
      style: {
        lineWidth: 0,
        fillOpacity: 0.65
      }
    }
  },
  legend: {
    position: 'bottom'
  },
  label: {
    content: ''
  },
  interactions: [
    {
      type: 'element-active'
    }
  ]
};

export const REVENUE_KEYS = [
  'subscription_monthly',
  'subscription_yearly',
  'video_consultation',
  'radiology'
] as const;
